export const UI_SVELTE_INIT = 'ui.svelte.init';

export const UI_SVELTE_UPDATE = 'ui.svelte.update';

export const DEFAULT_COMPONENT_NAME = 'Svelte Component';
